module.exports = __webpack_public_path__ + "img/tips_3.dfda28e9.png";